
import Vue from 'vue';

export default Vue.extend({
  name: 'Computed',
  props: {
    f: { type: Function, required: true },
    args: { required: false },
  },
  computed: {
    value() {
      return this.f(this.args);
    },
  },
});
